import React from "react"
import modStyl from './index.module.scss'

import poster1 from '../../assets/images/project-1.jpg'
import { Toast } from "antd-mobile"

type PropjectItem = Omit<ProjectItemProps, 'onClick'>

type ProjectItemProps = {
  id: number
  href: string
  title: string
  poster: string
  onClick: (item: PropjectItem)=> void
}

const ProjectItem: React.FC<ProjectItemProps> = ({ onClick, id, href, poster, title })=> {
  return (
    <div onClick={()=> onClick({ id, href, poster, title })} className={modStyl.articleWrapper}>
      <div className={modStyl.west}>
        <img src={poster} alt=""/>
      </div>
      <div className={modStyl.east}>
        <h2>{title}</h2>
        <p>
          <span>项目周期：</span>
          <span>2024.02.23-2024.04.13</span>
        </p>
      </div>
    </div>
  )
}

const Projects = () => {
  const data = [
    {id: 1, href: '', title: 'AI肝智库一乙肝治疗AI知识库项目', poster: poster1},
    {id: 2, href: '', title: 'AI肝智库一乙肝治疗AI知识库项目', poster: poster1},
    {id: 3, href: '', title: 'AI肝智库一乙肝治疗AI知识库项目', poster: poster1},
  ]
  const onClick = (item: PropjectItem)=> {
    Toast.show('敬请期待')
  }
  return (
    <>
      {
        data.map((item)=> <ProjectItem key={item.id} onClick={onClick} {...item}/>)
      }
    </>
  )
}

export default Projects